module.exports = __webpack_public_path__ + "img/waterfall.937eb118.gif";